<template>
    <Modal :show="show" @close="close()" class="text-center">

        <div class="modal-main">

            <!--<div class="modal-header">-->

                <!--<h2 class="modal-title">Make appointment with your Microbiome Coach</h2>-->
            <!--</div>-->

            <div class="modal-body">
                <iframe style="width:100%; height:100%" src="https://calendly.com/microba-microbiome-coach/15minute-microbiome-coach-session"></iframe>
            </div>

            <!--<div class="modal-footer">-->
                <!--<button class="btn btn-outline-primary" v-on:click="close">Dismiss</button>-->
            <!--</div>-->

        </div>

    </Modal>
</template>

<script>
import Modal from '@/components/models/ModalFull'
import JQuery from 'jquery'
let $ = JQuery

export default {
  name: 'ModalBooking',
  props: ['kitID'],
  extends: Modal,
  components: {
    Modal
  },
  methods: {
    onShow () {
      $('.app-body').addClass('modal-open')
    },
    close () {
      this.$emit('close')
      $('.app-body').removeClass('modal-open')
    }
  }
}
</script>

<style scoped lang="scss">
    .modal-main{
        height: 100%;
        width: 100%;
    }

    .modal-body{
        height: 100%;
        width: 100%;
        padding:0px;
        -webkit-overflow-scrolling: touch !important;
        overflow-y: auto !important;
    }

    .btn.plain.btn-booking {
        color: #3F9FCF;
        font-size:1.125rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/models/ModalBooking.vue